import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { EventMessageComponent } from '../../shared/index';
import { AddressService } from '../services/address.service';

@Component({
  selector: 'app-order-form-driver-complete',
  templateUrl: './order-form-driver-complete.component.html',
  styleUrls: ['./order-form-driver-complete.component.scss']
})
export class OrderFormDriverCompleteComponent implements OnInit {

  in_progress = false;
  err = {
    status: false,
    msg: null
  };

  constructor ( @Optional() @Inject( MAT_DIALOG_DATA ) public data: any,
                public dialogRef: MatDialogRef<OrderFormDriverCompleteComponent>,
                private snackBar: MatSnackBar,
                private addressService: AddressService) {
  }

  ngOnInit () {}

  send () {
    this.in_progress = true;
    this.addressService.completeOrder(this.data.id)
        .subscribe(res => {
          this.in_progress = false;
          this.handleServiceEvent('Поездка завершена');
          this.dialogRef.close();
        }, err => {
          this.err = {
                    status: true,
                    msg: err.message
                  };
          setTimeout(()=>{this.dialogRef.close()}, 1500);
        });
  }

  private handleServiceEvent ( msg ) {
    this.snackBar.openFromComponent( EventMessageComponent, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        message: msg
      }
    } );
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/order-form-driver-complete/order-form-driver-complete.component.ts